import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Mascot } from "@/components/Mascot";
import { Share, Plus, SquarePlus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PWAInstallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PWAInstallDialog({ open, onOpenChange }: PWAInstallDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center sm:text-center">
          <div className="flex justify-center mb-4">
            <Mascot mood="happy" size="lg" />
          </div>
          <DialogTitle className="text-xl">Add Grounded to Home Screen</DialogTitle>
          <DialogDescription className="text-base">
            Get quick access to find your perfect work cafe!
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Step 1 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
              1
            </div>
            <div className="flex-1">
              <p className="font-medium text-foreground">
                Tap the Share button
              </p>
              <p className="text-sm text-muted-foreground mt-1">
                Look for the share icon at the bottom of Safari
              </p>
              <div className="mt-2 inline-flex items-center gap-2 px-3 py-2 bg-secondary rounded-lg">
                <Share className="h-5 w-5 text-primary" />
                <span className="text-sm font-medium">Share</span>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
              2
            </div>
            <div className="flex-1">
              <p className="font-medium text-foreground">
                Scroll down and tap "Add to Home Screen"
              </p>
              <p className="text-sm text-muted-foreground mt-1">
                It might be in the second row of options
              </p>
              <div className="mt-2 inline-flex items-center gap-2 px-3 py-2 bg-secondary rounded-lg">
                <SquarePlus className="h-5 w-5 text-primary" />
                <span className="text-sm font-medium">Add to Home Screen</span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
              3
            </div>
            <div className="flex-1">
              <p className="font-medium text-foreground">
                Tap "Add" in the top right corner
              </p>
              <p className="text-sm text-muted-foreground mt-1">
                Grounded will appear on your home screen!
              </p>
            </div>
          </div>
        </div>

        <Button 
          onClick={() => onOpenChange(false)} 
          className="w-full"
          variant="secondary"
        >
          Got it!
        </Button>
      </DialogContent>
    </Dialog>
  );
}
